export default __webpack_public_path__ + "static/bottom-shadow-thin-cabecd1f646df77ddba25298eb2a61da.png";